import { useState } from "react";
import clsx from "clsx";

export default function FlipCard({ front, back, className }) {
  const [flipped, setFlipped] = useState(false);
  const onClick = (e) => {
    if (e.target.closest("a, button, input, video")) return;
    setFlipped((f) => !f);
  };
  return (
    <div
      role="button"
      aria-pressed={flipped}
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          setFlipped((f) => !f);
        }
      }}
      className={clsx("flip cursor-pointer outline-none", flipped && "is-flipped", className)}
      data-testid="flip-card"
    >
      <div className="flip-inner">
        <div className="flip-face">{front}</div>
        <div className="flip-face flip-back">{back}</div>
      </div>
    </div>
  );
}
